module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-3-red-8fa4c969635cefc259a777475556f5d6.svg";